"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardActionArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardActionAreaMixin = require("../../mixins/components/PropertyCardActionAreaMixin");
var StyledPropertyCardActionArea = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardActionArea",
  componentId: "c11n-8-107-0__sc-p25vvg-0"
})(["", ""], _PropertyCardActionAreaMixin.PropertyCardActionAreaMixin);
exports.StyledPropertyCardActionArea = StyledPropertyCardActionArea;